import {Component, Input, OnInit} from '@angular/core';
import {Option} from '../../classes/option';
import {StorageService} from '../../services/storage.service';

/**
 * Created by strunz on 12.05.2017.
 */


@Component({
  selector: 'slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
  @Input() option: Option;
  public min: number;
  public max: number;
  public range: number[];

  constructor(private storageService: StorageService) {
  }

  ngOnInit(): void {
    const items = this.option.getAllItems();
    this.min = 0;
    this.max = this.option.subItems.length - 1;
    this.range = [this.min, this.max];
    let min = this.min;
    for (const item in items) {
      if (items[item].active) {
        min = parseInt(item, 10);
        break;
      }
    }
    let max = this.max;
    for (let i = items.length - 1; i > min; i--) {
      if (items[i].active) {
        max = i;
        break;
      }
    }
    this.range = [min, max];

  }

  update(): void {
    const items = this.option.getAllItems();
    const rangeFrom: number = this.range[0];
    const rangeTo: number = this.range[1];
    if (rangeFrom === 0 && rangeTo === items.length - 1) {
      for (const itemIndex in items) {
        items[itemIndex].active = false;
      }
    } else {
      for (let itemIndex in items) {
        if (parseInt(itemIndex, 10) >= rangeFrom && parseInt(itemIndex, 10) <= rangeTo) {
          items[itemIndex].active = true;
        } else {
          items[itemIndex].active = false;
        }
      }
    }
    this.storageService.updateOptions();
  }

}
